<template>
  <div class="cropper-container" :class="classes">
    <Cropper
      ref="cropper"
      class="cropper"
      :src="imageUrl"
      alt="Image"
      :stencil-props="cropperConfig"
      @change="changeCropper"
    >
    </Cropper>
    <div class="button-container">
      <a class="primary-btn save-cropper js-save-cropper" @click="saveImage">
        {{ $t("Save") }}
      </a>
    </div>
  </div>
</template>
<script>
// https://www.npmjs.com/package/vue-cropperjs
import { Cropper } from "vue-advanced-cropper";
import useCropper from "../../../../packages/views/cropper/useCropper";
import store from "../../../../store";
import usePhoto from "../../usePhoto";

export default {
  components: {
    Cropper,
  },
  props: {
    imageUrl: {
      type: String,
    },
    classes: {
      type: String,
      default: () => "",
    },
    number: {
      type: Number,
      default: () => 1,
    },
  },
  methods: {
    saveImage() {
      this.$emit("save-modified");
    },
    changeCropper({ canvas }) {
      const image = this.compressImage(canvas);

      store.commit("photoCropper/SET_FILE", {
        index: this.number,
        value: image,
      });
    },
  },
  setup() {
    const { compressImage } = useCropper();
    const { cropperConfig } = usePhoto();

    return {
      cropperConfig,
      compressImage,
    };
  },
};
</script>
